import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

// Create context
const OrderDetailsContext = createContext();

// Create provider
export const OrderDetailsProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    pricing: {},
    order: {},
    sales: {},
    summary: [],
    program: [],
    transferHistory: null
  });

  const [editModes, setEditModes] = useState({});

  const toggleEditMode = (sectionKey, fieldKey) => {
    setEditModes(prev => {
      const key = `${sectionKey}-${fieldKey}`;
      return { ...prev, [key]: !prev[key] };
    });
  };

  const isFieldInEditMode = (sectionKey, fieldKey) => {
    const key = `${sectionKey}-${fieldKey}`;
    return !!editModes[key];
  };

  const updateField = (sectionKey, fieldKey, value) => {
    setFormData(prev => {
      const updatedSection = { ...prev[sectionKey], [fieldKey]: value };
      return { ...prev, [sectionKey]: updatedSection };
    });
    
    // Turn off edit mode after update
    toggleEditMode(sectionKey, fieldKey);
  };

  const value = {
    formData,
    setFormData,
    toggleEditMode,
    isFieldInEditMode,
    updateField
  };

  return (
    <OrderDetailsContext.Provider value={value}>
      {children}
    </OrderDetailsContext.Provider>
  );
};

OrderDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Create hook
export const useOrderDetails = () => {
  const context = useContext(OrderDetailsContext);
  if (!context) {
    throw new Error("useOrderDetails must be used within an OrderDetailsProvider");
  }
  return context;
};